var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader",staticStyle:{"background":"rgba(0, 0, 0, 0.3)","z-index":"2000"}},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }